import { first } from 'lodash';
import React from 'react';
import {
  CategoryPageType,
  ConsumerExploreDishFirstQuery,
  CuisineCategory,
  DishFirstSegmentFilter,
} from 'src/gqlReactTypings.generated.d';
import { CollectionHero } from 'src/pages/consumer/dish-first/explore/components/PageHero/CuisineCategoryPageHero/CollectionHero';
import { SubCuisineHero } from 'src/pages/consumer/dish-first/explore/components/PageHero/CuisineCategoryPageHero/SubCuisineHero';
import { TopLevelCuisineHero } from 'src/pages/consumer/dish-first/explore/components/PageHero/CuisineCategoryPageHero/TopLevelCuisineHero';
import { UseExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { match, P } from 'ts-pattern';

type IProps = {
  className?: string;
  data?: ConsumerExploreDishFirstQuery;
  cuisineCategory: CuisineCategory;
  filters: UseExploreUrl<DishFirstSegmentFilter>;
};

export const CuisineCategoryPageHero: React.FC<IProps> = ({ className, data, filters, cuisineCategory }) => {
  const { segmentFilters } = filters;
  const categoryFilter = first(segmentFilters);
  const firstSegment = data?.exploreFoodItems?.[0];

  return (
    match({ pageType: cuisineCategory.categoryPageContent?.pageType, categoryFilter, firstSegment })
      .with({ categoryFilter: P.not(undefined), firstSegment: P.not(P.nullish) }, ({ firstSegment }) => (
        <CollectionHero
          className={className}
          cuisineCategory={cuisineCategory}
          title={firstSegment.displayName}
          subtitle={firstSegment.subtitle}
        />
      ))
      .with({ pageType: CategoryPageType.TopLevel }, () => (
        <TopLevelCuisineHero className={className} cuisineCategory={cuisineCategory} />
      ))
      .with({ pageType: CategoryPageType.SubCuisine }, () => (
        <SubCuisineHero className={className} cuisineCategory={cuisineCategory} />
      ))
      // Should not happen
      .otherwise(() => null)
  );
};
